module.exports = __webpack_public_path__ + "img/truck-blue.bea18dd7.svg";